// @flow

import { object, record, decimal, locale } from 'common/json/extract';
import type { JSONValue } from 'common/types';
import { type Money, money as buildMoney } from 'common/types/money';

const extractValues = object(
  record({
    currency: locale,
    amount: decimal
  })
);

export function money(json: JSONValue): Money {
  const extractedMoney = extractValues(json);
  return buildMoney(extractedMoney.currency, extractedMoney.amount);
}
